import {AllArticleComponent} from './all-article/all-article.component';
import {CreateArticleComponent} from './create-article/create-article.component';
import {NavigationArticleComponent} from '../navigation-article/navigation-article.component';
import {ArticleDetailsComponent} from './article-details/article-details.component';
import {EditArticleComponent} from './edit-article/edit-article.component';
import {HistoryArticleComponent} from './history-article/history-article.component';
import {EditDetailsComponent} from './edit-details/edit-details.component';
import {SearchArticleComponent} from './search-article/search-article.component';


export const articleComponents = [
  AllArticleComponent,
  CreateArticleComponent,
  EditArticleComponent,
  HistoryArticleComponent,
  EditDetailsComponent,
  SearchArticleComponent,
  ArticleDetailsComponent
];
